import { Col, Container, Row } from "react-bootstrap";
import FilterSelect from "../components/FilterSelect";
import SearchBar from "../components/SeachBar/SearchBar";
import { Fragment, useState } from "react";
import { products } from "../utils/products";
import ShopList from "../components/ShopList";
import Banner from "../components/Banner/Banner";
import useWindowScrollToTop from "../hooks/useWindowScrollToTop";
import ProductListing from "../components/ProductDetails/ProductListing";
import WishList from "../components/WishList/WishList";
import About from "../components/Aboutus/About";
import MyAccount from "../components/More/MyAccount";

const ProfilePage = () => {

  useWindowScrollToTop();

  return (
    <Fragment>
      <Banner title="My Account" />
      {/* <section className="filter-bar"> */}
        <Container className="filter-bar-contianer">
          {/* <Row className="justify-content-center"> */}
            {/* <Col md={4}>
              <FilterSelect setFilterList={setFilterList} />
            </Col> */}
            {/* <Col md={8}>
              <SearchBar setFilterList={setFilterList} />
            </Col> */}
          {/* </Row> */}
        </Container>
        <Container>
       <MyAccount/>
          {/* <ShopList productItems={filterList} /> */}
        </Container>
      {/* </section> */}
    </Fragment>
  );
};

export default ProfilePage;
